import React from 'react';
import Button from '@mui/material/Button';
import {
  alpha,
  useTheme,
  type SxProps,
  type Theme,
} from '@mui/material/styles';

interface RunningPolicyButtonProps {
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export default function RunningPolicyButton({
  disabled = false,
  onClick,
}: Readonly<RunningPolicyButtonProps>) {
  const theme = useTheme();

  const sx: SxProps<Theme> = {
    height: 28,
    width: 130,
    minWidth: 130,
    borderRadius: '4px',
    border: `1px solid ${alpha(theme.palette.info.main, 0.5)}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.info.main,
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'none',
    paddingX: 1,
    '&:hover': {
      backgroundColor: alpha(theme.palette.info.main, 0.04),
      border: `1px solid ${alpha(theme.palette.info.main, 0.5)}`,
    },
    '&.Mui-disabled': {
      border: `1px solid ${alpha(theme.palette.action.disabled, 0.3)}`,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.action.disabled,
    },
  };

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled}
      disableRipple={disabled}
      onClick={onClick}
      sx={sx}
    >
      Policy Running...
    </Button>
  );
}
